import React from 'react';
import { LegalDocument } from '../components/legal/LegalDocument';

export const DataProcessingAgreementPage: React.FC = () => {
  return (
    <LegalDocument
      documentPath="/legal/data-processing-agreement.md"
      title="Data Processing Agreement"
      description="Our GDPR-compliant Data Processing Agreement (DPA) governing how admeru processes personal data on behalf of business customers."
    />
  );
};
